<template>
    <Wrapper
        :title="$t('revoke.accountRevoke')"
        :showBack="showBack"
        @on-back="$emit('on-back', $options.name)"
    >
        <template #content>
            <p class="indent-2">{{ $t('revoke.reconfirmText0') }}</p>
            <br />
            <p class="indent-2">{{ $t('revoke.reconfirmText1') }}</p>
        </template>
        <template #footer>
            <van-button type="info" class="w-full" :disabled="disabled" @click="handleClick">
                {{ $t('revoke.reconfirmCountdown', { second: count ? count + ' s' : '' }) }}
            </van-button>
        </template>
    </Wrapper>
</template>

<script>
import Vue from 'vue';
import { Button } from 'vant';
import useCountdown from '@/mixins/useCountdown';
import { isGray } from '@/lib/axios/config';
import Wrapper from './Wrapper.vue';
import { Target } from '../constant';

Vue.use(Button);

export default {
    name: 'Reconfirm',
    mixins: [useCountdown],
    components: {
        Wrapper,
    },
    props: {
        initialRevoke: {
            type: Object,
            required: true,
        },
    },
    computed: {
        showBack() {
            // 如果不显示条件和协议页面，该页面则为第一个页面，此时没有返回按钮
            return !!this.initialRevoke.showAcctDeletionAgreement;
        },
    },
    mounted() {
        const time = isGray ? 2 : 15;
        this.countdown(time, time);
    },
    methods: {
        handleClick() {
            this.$emit('on-step', { current: Target.Reconfirm, target: Target.RevokeAccount });
        },
    },
};
</script>
